import React, { useState, useEffect } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    Box,
    TextField,
    FormControl
} from "@material-ui/core";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { DownloadOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import HttpService from "../../services/httpService";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 850,
    },
    textField: {
        width: 100,
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 400,
    },
    actionButton: {
        backgroundColor: "#F47E46", // Primary background color
        color: "#FFF2EB",          // Primary text color
        "&:hover": {
            backgroundColor: "#E36F3E", // Darkened version of #F47E46
            color: "#FFD9C7",           // Lightened version of #FFF2EB
        }
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
        // border: '1px solid red'
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const EditedInwardingApproval = (props) => {
    const classes = useStyles();
    const [dataForEditedInwardingApproval, setDataForEditedInwardingApproval] = useState([]);
    const [procurementDetails, setProcurementDetails] = useState({});
    const [invoiceModal, setInvoiceModal] = useState(false);
    const [material, setMaterial] = useState({});
    const [transportationCharge, setTransportationCharge] = useState(0);
    const [freightCharge, setFreightCharge] = useState(0);
    const [gstAmounts, setGstAmounts] = useState(0);
    const [materialOriginalPrice, setMaterialOriginalPrice] = useState([]);
    const [editableFields, setEditableFields] = useState({
        transportationCharge: transportationCharge,
        gstAmounts: gstAmounts,
        freightCharge: freightCharge,
    });
    const [selectedOrderId, setSelectedOrderId] = useState("");
    const [updatedMat, setUpdatedMat] = useState(0);
    const [details, setDetails] = useState([]);
    const [gstOrginalAmount, setGstOriginalAmount] = useState(0);
    const [isGstUpdated, setIsGstUpdated] = useState(false);
    const [value, setValue] = useState("");
    const [textContent, setTextContent] = useState("");
    const [openRemarksModal, setOpenRemarksModal] = useState(false);
    const [isMaterialUpdated, setIsMaterialUpdated] = useState(false);
    const [remarks, setRemarks] = useState("");
    const [freightGstDetails, setFreightGstDetails] = useState({ type: "", rate: "0" });
    const [freightChargeWOGst, setFreightChargeWOGst] = useState(0);
    const freightGstPercent = ["0", "5", "12", "18", "28"];

    // Function to handle the change in GST Rates
    const freightGstRateChangeHandler = (event, value) => {
        setFreightGstDetails({ ...freightGstDetails, rate: value });
        // Calculate the percentage amount and add it to freightCharge
        let freightChargeWithGst = freightChargeWOGst + (+freightChargeWOGst * +value) / 100;
        setFreightCharge(freightChargeWithGst.toFixed(2));
        const procDetailObj = { ...procurementDetails };
        procDetailObj.grandTotal =
            procDetailObj?.grandTotal - freightCharge + +freightChargeWithGst;
        // procDetailObj.freight = +event.target.value;

        setProcurementDetails(procDetailObj);
        setEditableFields({
            ...editableFields,
            freightCharge: +freightChargeWithGst,
        });
        // const procurementObj = { ...procurementDetails };
        // procurementDetails.gstDetails[0].rate = value;
        // priceCal(details.materialIdOfInwarding._id, procurementDetails, details);
        // setProcurementDetails(procurementObj);
    }

    // function to get edited inwarding approvals data
    const getDataForEditedInwardingApproval = async () => {
        props.setLoading(true);
        try {
            const response = await HttpService.getDataForEditedInwardingApproval();
            setDataForEditedInwardingApproval(response.data);
            // setDataToDisplay(response.data);
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // Function to open invoice Modal
    const openInvoiceModalHelper = (materialId, data, value) => {
        setInvoiceModal(true);
        priceCal(materialId, data, value);
        setMaterial(
            procurementDetails?.materials?.filter(
                (material) => material?.materialId?._id === materialId
            )[0]
        );
        // setIndex(i)
    };

    // Function to get procurement Details based on the click on action button
    const openInvoiceModalHandler = async (value) => {
        setSelectedOrderId(value?.procurementId?.orderId);
        // setValue(value);
        setDetails(value);
        props.setLoading(true);
        try {
            const result = await HttpService.getProcurementByOrderIdForInwarding(
                value?.procurementId?.orderId
            );
            setProcurementDetails(result.data);
            let arr = result?.data?.materials?.map((el) => el.requestedPrice);
            setMaterialOriginalPrice(arr);
            // setOpenDialog(true)
            openInvoiceModalHelper(
                value?.materialIdOfInwarding?._id,
                result.data,
                value
            );
        } catch (error) {
            console.error(error);
            // props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false);
    };

    // A helper function to calculate the necessary fields when rate, gst, freight, or transportation charges are changed
    const priceCal = (materialId, data, value) => {
        let total = 0;
        let subTotal = 0;
        let presicionDiff = 0;
        let toatlGstAmount = 0;
        let totalQty = 0;
        data.materials.forEach((mat) => {
            if (
                mat.materialId._id.toString() === materialId.toString() &&
                mat?.materialId?._id?.toString() ===
                value?.materialIdOfInwarding?._id?.toString()
            ) {
                // mat.materialTotal = +mat.requestedQuantity * +mat.requestedPrice || +mat.materialId.pricePerUnit;
                mat.materialTotal =
                    +value?.InwardingRecords?.inwardedQty * +mat.requestedPrice ||
                    +mat.materialId.pricePerUnit;
                total += mat.materialTotal;
                // totalQty += mat.requestedQuantity;
                totalQty += +value?.InwardingRecords?.inwardedQty;
                mat.isAdded = true;
            }
        });

        if (data.discount) {
            // total = total - data.discount;
            let discountAmount = (data.discount / 100) * total; // Calculate the discount amount
            total -= discountAmount;
        } else {
            data.discount = 0;
        }
        subTotal = total;

        if (data.gstRequired) {
            data.gstDetails.forEach((gstDetail) => {
                gstDetail.gstAmount = Number(
                    Number.parseFloat((gstDetail.rate * total) / 100).toFixed(2)
                );
                toatlGstAmount += gstDetail.gstAmount;
            });
            total = total + toatlGstAmount;
        } else {
            toatlGstAmount = 0;
        }

        if (value.InwardingRecords.freightCharge) {
            total = total + +value.InwardingRecords.freightCharge;
        } else {
            data.freight = 0;
        }

        if (data.transportationCharge) {
            total = total + data.transportationCharge;
        } else {
            data.transportationCharge = 0;
        }

        data.totalQty = +totalQty;
        data.subTotal = +subTotal;
        data.grandTotal = +total;
        presicionDiff =
            Number(total)?.toFixed(2) -
            Number(Number.parseFloat(subTotal).toFixed(2)) -
            Number(Number.parseFloat(toatlGstAmount).toFixed(2)) +
            Number(Number.parseFloat(data.discount).toFixed(2)) -
            Number(Number.parseFloat(data.transportationCharge).toFixed(2)) -
            Number(Number.parseFloat(data.freight).toFixed(2));
        data.presicionDiff = Number.parseFloat(presicionDiff).toFixed(2);
        // let word = numWords(Math.round(+procurementDetails.grandTotal));
        // procurementDetails.amountInWords = word.toUpperCase();
        setTransportationCharge(data?.transportationCharge);
        setFreightCharge(value.InwardingRecords.freightCharge);
        setGstAmounts(toatlGstAmount);
        setEditableFields({ ...editableFields, gstAmounts: data?.gstDetails });
        setUpdatedMat(data.grandTotal);
        setProcurementDetails(data);
        return data;
    };

    // function to handle change in GST
    const gstChangeHandler = (event) => {
        if (+event.target.value > +gstOrginalAmount) {
            return props.setSnackInfo(
                "GST Amount can't be greater than Requested GST Amount",
                "error"
            );
        }
        setGstAmounts(event.target.value);
        setIsGstUpdated(true);
        let val = (+event.target.value / procurementDetails?.grandTotal) * 100;
        procurementDetails.grandTotal =
            procurementDetails?.grandTotal - gstAmounts + +event.target.value;
        setEditableFields({ ...editableFields, gstAmounts: +val.toFixed(0) });
    };

    // function to handle change in transportation charges
    const transportationChargesChangeHandler = (event) => {
        setTransportationCharge(event.target.value);
        procurementDetails.grandTotal =
            procurementDetails?.grandTotal -
            transportationCharge +
            +event.target.value;
        setEditableFields((prevState) => ({
            ...editableFields,
            transportationCharge: +event.target.value,
        }));
    };

    // function to handle change in freight charges
    const freightChargesChangeHandler = (event) => {
        if (+event.target.value <= 0)
            return props.setSnackInfo(
                "Please Enter Value Greater than 0",
                "warning"
            );
        setFreightCharge(+event.target.value);
        setFreightChargeWOGst(+event.target.value);
        setFreightGstDetails({ ...freightGstDetails, rate: 0 });
        const procDetailObj = { ...procurementDetails };
        procDetailObj.grandTotal =
            procDetailObj?.grandTotal - freightCharge + +event.target.value;

        setProcurementDetails(procDetailObj);
        setEditableFields({
            ...editableFields,
            freightCharge: +event.target.value,
        });
    };

    // Function to Open Remarks Modal
    const openRemarksModalHandler = (status) => {
        if (status === "Approved") {
            setTextContent("Approval");
        }
        if (status === "Rejected") {
            setTextContent("Rejection");
        }
        setValue(status);
        setOpenRemarksModal(true);
    };

    // function to handle price change of material
    const materialPriceChangeHandler = (index, event) => {
        // Log the index and the new value
        if (+event.target.value <= 0)
            return props.setSnackInfo(
                "Please Enter Value Greater than 0",
                "warning"
            );

        // Set isMaterialUpdated to true
        setIsMaterialUpdated(true);
        setFreightGstDetails({ ...freightGstDetails, rate: 0 });

        // Log the original material price

        // Check if the new price is greater than the original requested price
        if (+event.target.value > +materialOriginalPrice[index]) {
            // Display an error message and return if the new price is greater
            props.setSnackInfo(
                "New Rate can't be greater than original Requested Rate",
                "error"
            );
            return;
        }
        // Create a copy of procurementDetails
        const updatedProcurementDetails = { ...procurementDetails };
        // Update the requested price for the material at the specified index
        updatedProcurementDetails.materials[index].requestedPrice =
            event.target.value;

        // Initialize variables for calculations
        let total = 0;
        let subTotal = 0;
        let presicionDiff = 0;
        let toatlGstAmount = 0;
        let totalQty = 0;

        // Calculate total and total quantity for all materials
        updatedProcurementDetails.materials.forEach((mat, i) => {
            if (mat.isAdded === true) {
                // mat.materialTotal = +mat.requestedQuantity * +mat.requestedPrice || +mat.materialId.pricePerUnit;
                mat.materialTotal =
                    +details?.InwardingRecords?.inwardedQty * +mat.requestedPrice ||
                    +mat.materialId.pricePerUnit;
                total += mat.materialTotal;
                // totalQty += mat.requestedQuantity;
                totalQty += details?.InwardingRecords?.inwardedQty;
            }
        });

        // Calculate subTotal
        if (updatedProcurementDetails.discount) {
            // total = total - updatedProcurementDetails.discount;
            let discountAmount = (updatedProcurementDetails.discount / 100) * total; // Calculate the discount amount
            total -= discountAmount;
        } else {
            updatedProcurementDetails.discount = 0;
        }
        subTotal = total;

        // Calculate GST amounts
        if (updatedProcurementDetails.gstRequired) {
            updatedProcurementDetails.gstDetails.forEach((gstDetail) => {
                gstDetail.gstAmount = Number(
                    Number.parseFloat((gstDetail.rate * total) / 100).toFixed(2)
                );
                toatlGstAmount += gstDetail.gstAmount;
            });
            total = total + toatlGstAmount;
        } else {
            toatlGstAmount = 0;
        }

        // Calculate total with freight
        if (details.InwardingRecords.freightCharge) {
            total = total + details.InwardingRecords.freightCharge;
        } else {
            updatedProcurementDetails.freight = 0;
        }

        // Calculate total with transportation charge
        if (updatedProcurementDetails.transportationCharge) {
            total = total + updatedProcurementDetails.transportationCharge;
        } else {
            updatedProcurementDetails.transportationCharge = 0;
        }

        // Update procurementDetails with calculated values
        updatedProcurementDetails.totalQty = +totalQty;
        updatedProcurementDetails.subTotal = +subTotal;
        updatedProcurementDetails.grandTotal = +total;
        presicionDiff =
            Number(total)?.toFixed(2) -
            Number(Number.parseFloat(subTotal).toFixed(2)) -
            Number(Number.parseFloat(toatlGstAmount).toFixed(2)) +
            Number(Number.parseFloat(updatedProcurementDetails.discount).toFixed(2)) -
            Number(
                Number.parseFloat(
                    updatedProcurementDetails.transportationCharge
                ).toFixed(2)
            ) -
            Number(Number.parseFloat(updatedProcurementDetails.freight).toFixed(2));
        updatedProcurementDetails.presicionDiff =
            Number.parseFloat(presicionDiff).toFixed(2);

        // Update state with new values
        setTransportationCharge(updatedProcurementDetails?.transportationCharge);
        setFreightCharge(details.InwardingRecords.freightCharge);
        setFreightChargeWOGst(details.InwardingRecords.freightCharge);
        setGstAmounts(toatlGstAmount);
        setGstOriginalAmount(toatlGstAmount);
        setEditableFields({
            ...editableFields,
            gstAmounts: updatedProcurementDetails?.gstDetails,
        });
        setUpdatedMat(updatedProcurementDetails.grandTotal);

        // Update the requested price for the material at Inwarding approvals
        setDetails((prevState) => ({
            ...prevState,
            InwardingRecords: {
                ...prevState.InwardingRecords,
                inwardedRate: event.target.value
            }
        }));

        // updating the procurementDetails
        setProcurementDetails(updatedProcurementDetails);

        // Return the updated procurementDetails
        // return updatedProcurementDetails;
    };

    // Funtion to get type of the file do display
    const getFileType = (url) => {
        const extension = url?.split(".").pop()?.toLowerCase();
        if (extension === "pdf") {
            return "pdf";
        } else if (
            extension === "jpg" ||
            extension === "jpeg" ||
            extension === "png" ||
            extension === "gif"
        ) {
            return "image";
        } else {
            return "unknown";
        }
    };

    // Funtion to close Remarks Modal
    const closeRemarksModalHandler = () => {
        setOpenRemarksModal(false);
        setRemarks("");
    };

    // Function to handle remarks input
    const remarksInputHandler = async (e) => {
        setRemarks(e.target.value);
        // if (e.target.value.trim() === "") return props.setSnackInfo("Please Enter Remarks", "error");
    };

    // Function to handle FE Action on Edited PO
    const handleEditedPoApproval = async (e) => {
        // Set loading state to true to indicate a process is ongoing
        props.setLoading(true);
        setOpenRemarksModal(false);

        // Create an object to hold the updated procurement details and status
        let updateObj = {
            status: value,
            remarks: remarks.trim(),
            freightCharge: freightCharge,
            freightChargeWOGst: freightChargeWOGst,
            freightGstDetails: freightGstDetails,
            inwardingRecordId: details.InwardingRecords._id,
            ...details,
        };

        // If materials have been updated, include the updated materials information
        if (isMaterialUpdated === true) {
            updateObj.isMaterialUpdated = isMaterialUpdated;
            updateObj.materials = procurementDetails?.materials;
        }
        try {
            // Check if remarks are entered, if not show a warning and return
            if (remarks.trim().length === 0) {
                // props.setSnackInfo("Please enter remarks before submitting.", "warning");
                props.setSnackInfo(`Please Enter ${textContent} Remarks Before Submitting`, "warning");
                props.setLoading(false);
                return;
            }
            let payload = { status: value, remarks: remarks, inwardingRecordId: details.InwardingRecords._id }
            const response = await HttpService.updateEditedPOFinanceApprovalStatus(updateObj);
            // window.open(response.data.editedPoLink);
            props.setSnackInfo(response?.data?.msg ?? "Updated Successfully", response?.data?.type ?? "success");
        } catch (error) {
            console.error("Error -> ", error);
            props.setSnackInfo("Something went Wrong!", "error");
        }
        setRemarks("");
        setInvoiceModal(false);
        props.setLoading(false);
        getDataForEditedInwardingApproval();
    };

    // function to download procurements
    const poDownloadHandler = () => {
        try {
            // Downloading the po when clicked on the PO Number
            window.open(procurementDetails.poLink);
        } catch (error) {
            console.error("Error -> ", error);
        }
    };

    useEffect(() => {
        getDataForEditedInwardingApproval();
    }, []);

    return (
        <div>
            <div
                style={{
                    marginBottom: 20,
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Paper className={classes.paper}>
                    <center>
                        <h2>Edited Inwarding Approval</h2>
                    </center>
                </Paper>
            </div>

            {/* Table for displaying data sent for Edited Inwarding Approvals */}
            <TableContainer TableContainer component={Paper}>
                <Table
                    className={classes.table}
                    size="small"
                    aria-label="customized table"
                    stickyHeader
                >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Sl No</StyledTableCell>
                            <StyledTableCell>PO No.</StyledTableCell>
                            <StyledTableCell>Inwarding Id</StyledTableCell>
                            <StyledTableCell>Inwarded Date</StyledTableCell>
                            <StyledTableCell>Invoice Date</StyledTableCell>
                            <StyledTableCell>Invoice No.</StyledTableCell>
                            <StyledTableCell>PO Qty</StyledTableCell>
                            <StyledTableCell>Inwarded Qty</StyledTableCell>
                            <StyledTableCell>GST</StyledTableCell>
                            <StyledTableCell>Freight Charges</StyledTableCell>
                            <StyledTableCell>Total Value</StyledTableCell>
                            <StyledTableCell> Action </StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataForEditedInwardingApproval?.map((el, i) => {
                            return (
                                <StyledTableRow key={i + 1}>
                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                    <StyledTableCell>
                                        {el?.procurementId?.orderId}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardingId}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {moment(el?.InwardingRecords?.dateOfInwarded).format(
                                            "DD-MM-YYYY"
                                        )}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.invoiceDate
                                            ? moment(el.InwardingRecords.invoiceDate).format("DD-MM-YYYY")
                                            : "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.invoiceNumber}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.bomQuantity?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>{el?.InwardingRecords?.inwardedQty?.toFixed(2)}</StyledTableCell>
                                    <StyledTableCell>
                                        {el?.gstDetails[0]?.gstRate?.toFixed(2) || "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.freightCharge?.toFixed(2) || "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>{(+el?.InwardingRecords?.inwardedQty * +el?.InwardingRecords?.inwardedRate).toFixed(2)}</StyledTableCell>
                                    <StyledTableCell>
                                        <>
                                            <Button
                                                variant="contained"
                                                className={classes.actionButton}
                                                onClick={() => openInvoiceModalHandler(el)}
                                            >
                                                Action
                                            </Button>
                                            {/* <Button variant="contained" color="primary" style={{ background: "#f50057", margin: 5 }} onClick={() => handleSubmit('Rejected', el)}>
                                                Reject
                                            </Button> */}
                                        </>
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* PO Invoice Modal */}
            <Modal
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                title={`Edited Inwarding - ${selectedOrderId}`}
                centered
                open={invoiceModal}
                onCancel={() => setInvoiceModal(false)}
                width={1500}
                maskClosable={true}
                footer={null}
            >
                <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ border: "1px solid #000", flex: 1, padding: "2px" }}>
                        <div
                            className="container"
                            style={{ width: "100%", marginTop: "2%" }}
                        >
                            <div>
                                <div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td rowSpan="3" style={{ width: "50%" }}>
                                                    <div className="invoice">Invoice to:</div>
                                                    <div className="invoice-to">
                                                        <b>Decorpot Pvt Ltd.</b>
                                                        <div>
                                                            #17, 18th Cross Rd, Sector 3, HSR Layout,
                                                            Bengaluru - 560102
                                                        </div>
                                                        <div className="gstno">Gst No-29AAWCS3842H1ZO</div>
                                                        <div>State Name : Karnataka, Code : 29</div>
                                                        <div>E-Mail: sales@decorpot.com</div>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Voucher No.</div>
                                                    <div className="vou-no">
                                                        <b>{procurementDetails?.orderId}</b>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Dated:</div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {moment(procurementDetails?.createdAt).format(
                                                                "DD-MM-YYYY"
                                                            )}
                                                        </b>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>&nbsp;</td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Mode/Terms of Payment</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>
                                                    <div>Supplier's Ref./Order No.</div>
                                                    <div className="vou-no">
                                                        {/* <b>{procurementDetails?.orderId}</b> */}
                                                        <Button
                                                            onClick={poDownloadHandler}
                                                            color="secondary"
                                                            variant="outlined"
                                                        >
                                                            <b>
                                                                { procurementDetails?.orderId }
                                                            </b>
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Other Reference(s)/Comments</div>
                                                    <div className="vou-no">
                                                        <b>{procurementDetails?.comment}</b>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td rowSpan="2" style={{ width: "50%" }}>
                                                    <div className="invoice">Supplier</div>
                                                    <div className="invoice-to">
                                                        <b>{procurementDetails?.vendorId?.name}</b>
                                                        <div>{procurementDetails?.vendorId?.address}</div>
                                                        <div className="row">
                                                            <div
                                                                className="col-md-2"
                                                                style={{ float: "left" }}
                                                            >
                                                                GSTIN/UIN
                                                            </div>
                                                            <div className="col-md-10">
                                                                :&nbsp;
                                                                {procurementDetails?.vendorId?.gstinNumber}
                                                            </div>
                                                            <div className="row">
                                                                <div
                                                                    className="col-md-2"
                                                                    style={{ float: "left" }}
                                                                >
                                                                    State Name
                                                                </div>
                                                                <div className="col-md-10">
                                                                    :&nbsp;Karnataka, Code : 29
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>Dispatch through</div>
                                                </td>
                                                <td>
                                                    <div>Destination</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="1">
                                                    <div>Terms of Delivery</div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Invoice No.</div>
                                                    <div className="vou-no">
                                                        <b>{details?.InwardingRecords?.invoiceNumber}</b>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div>
                                    <Table size="small" aria-label="custom pagination table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Sl. No.</TableCell>
                                                <TableCell>Description of Goods</TableCell>
                                                <TableCell>Due On</TableCell>
                                                <TableCell>Quantity</TableCell>
                                                <TableCell>Rate</TableCell>
                                                <TableCell>per</TableCell>
                                                <TableCell>Disc. %</TableCell>
                                                <TableCell>Amount</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableHead>
                                            {procurementDetails?.materials?.map(
                                                (material, index) =>
                                                    material.isAdded && (
                                                        <TableRow key={index}>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>
                                                                <div>
                                                                    <b>{material?.materialId?.code}</b>
                                                                </div>
                                                                <br />
                                                                <div className="desc">
                                                                    [
                                                                    {material?.materialId?.aliasName
                                                                        ? material?.materialId?.aliasName
                                                                        : material?.materialId.name}
                                                                    ]
                                                                </div>
                                                                <br />
                                                                {material?.remark && (
                                                                    <div className="desc">{material?.remark}</div>
                                                                )}
                                                            </TableCell>
                                                            <TableCell>45 Days</TableCell>
                                                            <TableCell>
                                                                {details?.InwardingRecords?.inwardedQty}
                                                            </TableCell>
                                                            <TableCell>
                                                                {/* {material?.requestedPrice} */}
                                                                <FormControl style={{ width: 200 }}>
                                                                    <TextField
                                                                        style={{ margin: "5px" }}
                                                                        size="small"
                                                                        id={`requestedPrice-${index}`}
                                                                        label="Requested Price"
                                                                        value={material?.requestedPrice}
                                                                        variant="outlined"
                                                                        name={`requestedPrice-${index}`}
                                                                        type="number"
                                                                        onChange={(e) =>
                                                                            materialPriceChangeHandler(index, e)
                                                                        }
                                                                    />
                                                                </FormControl>
                                                            </TableCell>
                                                            <TableCell>{material?.unitId.name}</TableCell>
                                                            <TableCell>
                                                                {procurementDetails?.discount}
                                                            </TableCell>
                                                            <TableCell>
                                                                ₹
                                                                {(
                                                                    material?.materialTotal?.toFixed(2) -
                                                                    (procurementDetails?.discount *
                                                                        material?.materialTotal) /
                                                                    100
                                                                ).toFixed(2)}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                            )}
                                        </TableHead>
                                    </Table>
                                </div>

                                <div>
                                    <Table>
                                        <TableBody>
                                            <TableRow key="1">
                                                <TableCell>Total Qty</TableCell>
                                                <TableCell>{procurementDetails?.totalQty}</TableCell>
                                            </TableRow>
                                            {/*
                                            <TableRow key="2">
                                                <TableCell>
                                                    <i>Discount</i>
                                                </TableCell>
                                                <TableCell>{procurementDetails?.discount}%</TableCell>
                                            </TableRow>
                                            */}
                                            <TableRow key="2">
                                                <TableCell>
                                                    Freight Approved (W/O GST)
                                                </TableCell>
                                                <TableCell>₹{(procurementDetails?.totalFreightApproved || 0)?.toFixed(2)}</TableCell>
                                            </TableRow>
                                            <TableRow key="3">
                                                <TableCell>
                                                    <i>Freight Charge</i>
                                                </TableCell>
                                                <TableCell>
                                                    {/* {freightCharge?.toFixed(2)} */}
                                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                                        <FormControl style={{ width: 300 }}>
                                                            <TextField
                                                                style={{ margin: "5px" }}
                                                                size="small"
                                                                id="outlined-basic"
                                                                label="Freight Charge"
                                                                value={freightCharge}
                                                                variant="outlined"
                                                                name="freight charge"
                                                                type="number"
                                                                onChange={(e) => freightChargesChangeHandler(e)}
                                                            />
                                                        </FormControl>
                                                        <Autocomplete
                                                            value={freightGstDetails?.rate}
                                                            onChange={(e, value) => freightGstRateChangeHandler(e, value)}
                                                            id="percent"
                                                            options={freightGstPercent}
                                                            getOptionLabel={(option) => `${option}%`}
                                                            style={{ width: '48%' }}
                                                            renderInput={(params) => <TextField {...params} label="Select GST percent for Freight" fullWidth variant="outlined" />}
                                                        />
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="4">
                                                <TableCell>
                                                    <i>Gst Rate</i>
                                                </TableCell>
                                                <TableCell>
                                                    {procurementDetails?.gstDetails?.length > 0 ? procurementDetails?.gstDetails[0]?.rate : "N/A"}%
                                                    {/*
                                                    <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            style={{ margin: "5px" }}
                                                            size="small"
                                                            id="outlined-basic"
                                                            label="Transportation Charge"
                                                            value={transportationCharge}
                                                            variant="outlined"
                                                            name="Transportation Charge"
                                                            type="number"
                                                            onChange={(e) =>
                                                                transportationChargesChangeHandler(e)
                                                            }
                                                        />
                                                    </FormControl>
                                                    */}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="5">
                                                <TableCell>
                                                    <i>Gst Charge</i>
                                                </TableCell>
                                                <TableCell>
                                                    {gstAmounts}
                                                    {/*
                                                    <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            style={{ margin: "5px" }}
                                                            size="small"
                                                            id="outlined-basic"
                                                            label="Gst Charge"
                                                            value={gstAmounts}
                                                            variant="outlined"
                                                            name="Gst Charge"
                                                            type="number"
                                                            onChange={(e) => gstChangeHandler(e)}
                                                        />
                                                    </FormControl>
                                                    */}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="6">
                                                <TableCell>Total Amount</TableCell>
                                                <TableCell>
                                                    ₹{procurementDetails?.grandTotal?.toFixed(2)}
                                                    {/* ₹{Math.round(procurementDetails?.grandTotal)} */}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="7">
                                                <TableCell><b>Was Rejected For</b></TableCell>
                                                <TableCell style={{ color: "red" }}>
                                                    <b>
                                                        {details?.InwardingRecords?.remarks?.length > 0 ? details?.InwardingRecords?.remarks[0]?.msgBody : "N/A"}
                                                    </b>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ border: "1px solid #000", flex: 1, padding: "" }}>
                        {
                            // Display pdf when file type is pdf
                            getFileType(details?.InwardingRecords?.invoice) === "pdf" ? (
                                <iframe
                                    title="PDF Viewer"
                                    src={`https://docs.google.com/gview?url=${details?.InwardingRecords?.invoice}&embedded=true`}
                                    style={{
                                        width: "fit-content",
                                        height: "800px",
                                        border: "none",
                                    }}
                                ></iframe>
                            ) : // Display image when file is image
                                getFileType(details?.InwardingRecords?.invoice) === "image" ? (
                                    <img
                                        src={details?.InwardingRecords?.invoice}
                                        width="100%"
                                        alt="Image"
                                    ></img>
                                ) : (
                                    // Display warning when file type is not supported
                                    <p style={{ color: "red", padding: "10%" }}>
                                        <b>File Format Not Supported</b>
                                    </p>
                                )
                        }
                    </div>
                </div>

                <DialogActions>
                    <Button
                        onClick={() => openRemarksModalHandler("Rejected")}
                        color="secondary"
                        variant="outlined"
                    >
                        Reject
                    </Button>
                    <Button
                        onClick={() => openRemarksModalHandler("Approved")}
                        color="primary"
                        variant="contained"
                        style={{ background: "#2b7636", margin: 5 }}
                    >
                        Approve
                    </Button>
                </DialogActions>
            </Modal>

            {/* Remarks Dialog Box  */}
            <div>
                <Dialog
                    open={openRemarksModal}
                    onClose={closeRemarksModalHandler}
                    aria-labelledby="form-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText>Enter {textContent} Remarks</DialogContentText>
                        <TextField
                            id="remarks"
                            name="Remarks"
                            label="Add Remarks"
                            variant="outlined"
                            type="text"
                            value={remarks}
                            onChange={remarksInputHandler}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={closeRemarksModalHandler}
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleEditedPoApproval}
                            variant="contained"
                            color="primary"
                            style={{ background: "#2b7636", margin: 5 }}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(
    EditedInwardingApproval
);